
import React from 'react';
import Navbar from '../components/Navbar';
import AnimatedBackground from '../components/AnimatedBackground';

const Privacy = () => {
  return (
    <div className="min-h-screen w-full overflow-hidden">
      <AnimatedBackground />
      <Navbar />
      
      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="max-w-4xl mx-auto bg-black/50 backdrop-blur-lg rounded-xl p-8 border border-white/10 text-left">
          <h1 className="text-3xl font-bold mb-8 text-white">Privacy Policy</h1>
          <p className="text-gray-300 mb-4">Last updated: March 31, 2025</p>
          
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 mb-6">
              At Cloudima we take your privacy very seriously. This document describes what personal data we collect, how we use it, and what your rights are.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Data Controller</h2>
            <p className="text-gray-300 mb-4">
              Currently Cloudima is a project in development, managed from Seville, Spain. If you have any questions or requests regarding your personal information, you can contact us at: contact@cloudima.org
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Data We Collect</h2>
            <p className="text-gray-300 mb-4">
              When you register for Cloudima or use our services, we may collect and process the following data:
            </p>
            <ul className="list-disc pl-6 text-gray-300 mb-6 space-y-2">
              <li>First and last name</li>
              <li>Email address</li>
              <li>Access keys (API Key or credentials) to your cloud provider</li>
              <li>Technical session information (cookies, current project, current architecture, etc.)</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Purpose of Processing</h2>
            <p className="text-gray-300 mb-4">
              We use your data to:
            </p>
            <ul className="list-disc pl-6 text-gray-300 mb-6 space-y-2">
              <li>Create and manage your Cloudima account</li>
              <li>Allow you to design and deploy cloud infrastructure</li>
              <li>Keep your session active and save your progress</li>
              <li>Improve our services and detect errors</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Legal Basis</h2>
            <p className="text-gray-300 mb-4">
              The legal basis for processing your data is your consent and the execution of the requested service (providing you access to the platform).
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Data Retention</h2>
            <p className="text-gray-300 mb-4">
              Your personal data will be retained while you maintain an active account. If you decide to delete it, we will delete or anonymize your data within a reasonable time frame, except as required by law.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Data Sharing</h2>
            <p className="text-gray-300 mb-4">
              We do not share your data with third parties unless it is strictly necessary for the operation of the service (for example, for authentication, cloud deployment, or payment processing if you contract a premium plan).
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Cookies</h2>
            <p className="text-gray-300 mb-4">
              We use technical cookies to keep your session active and save the state of your project. For more information, please see our <a href="/cookies" className="text-blue-400 hover:text-blue-300">Cookie Policy</a>.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">8. User Rights</h2>
            <p className="text-gray-300 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-gray-300 mb-6 space-y-2">
              <li>Access your data</li>
              <li>Rectify it if it is incorrect</li>
              <li>Request its deletion</li>
              <li>Object to or limit its processing</li>
              <li>Port your data to another provider</li>
            </ul>
            <p className="text-gray-300 mb-4">
              You can exercise these rights by writing to us at: contact@cloudima.org
            </p>
          </div>
        </div>
      </div>
      
      <footer className="py-8 border-t border-gray-700/30 relative z-10 bg-black/30 backdrop-blur-sm">
        <div className="container px-4 mx-auto">
          <div className="mt-4 text-center">
            <span className="text-sm text-gray-400">© {new Date().getFullYear()} Cloudima. All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;
